import { default as videojs } from 'video.js';
import { QualitySelectionRepresentation } from '../../../plugin';
import { PlanetVideoJs } from '../models';
import { VhsHandler } from '../vhs-handler';
import { QualityMenuItem } from './quality-menu-item';

const MenuButton: typeof videojs.MenuButton = videojs.getComponent('MenuButton');

export class QualityMenuButton extends MenuButton {

    static readonly ComponentName: string = 'QualityMenuButton';

    player_: PlanetVideoJs;

    private representations: QualitySelectionRepresentation[] = [];
    private hideThreshold_: number;

    constructor(player: PlanetVideoJs, options: videojs.MenuButtonOptions) {
        super(player, options);
        this.hideThreshold_ = 1;
        const vhs: VhsHandler = player.tech('_').vhs;
        if (vhs) {
            this.representations = vhs.representations();
            if (!this.representations) {
                return;
            }
            if (this.representations.length <= 1) {
                this.hide();
            }
        } else {
            this.representations = [];
        }
    }

    name(): string {
        return QualityMenuButton.ComponentName;
    }

    buildCSSClass(): string {
        return `vjs-icon-cog ${super.buildCSSClass()}`;
    }

    createItems(): QualityMenuItem[] {
        const vhs: VhsHandler = this.player_.tech('_')?.vhs;
        if (vhs) {
            this.representations = [...vhs.representations()];
            let index = 0;
            const auto: QualityMenuItem = new QualityMenuItem(this.player_, {
                representations: this.representations,
                representation: null,
                representationIndex: -1,
                isAuto: true,
                label: 'Auto',
                selectable: true,
                multiselectable: false,
                selected: true,
            });

            const items: QualityMenuItem[] = [auto];

            this.representations
                .sort((a: QualitySelectionRepresentation, b: QualitySelectionRepresentation) => a.height < b.height ? 1 : -1)
                .forEach((i: QualitySelectionRepresentation) => {
                    let label: string;
                    if (i.height) {
                        label = `${i.height}p`;
                    } else {
                        label = 'Audio only';
                    }

                    const item: QualityMenuItem = new QualityMenuItem(this.player_, {
                        representations: this.representations,
                        representation: i,
                        representationIndex: index++,
                        label: label,
                        selected: false,
                        selectable: true,
                        multiSelectable: false,
                    });
                    item.addClass(`vjs-quality-${i.bandwidth}`);
                    items.push(item);
                });

            /**
             * Sort AFTER the creation of the Items because the selection is managed by the representationIndex came
             * from the playlist.m3u8
             */
            this.representations.sort((a: QualitySelectionRepresentation, b: QualitySelectionRepresentation) => a.bandwidth < b.bandwidth ? 1 : -1);

            return items;
        }
        return [];
    }
}

videojs.registerComponent(QualityMenuButton.ComponentName, QualityMenuButton);
